import React, { useState, useEffect, useRef } from 'react';
import './CellEditor.css';

const CellEditor = ({ value, position, onChange, onSave, onCancel }) => {
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef(null);

  // Input değişiklik
  const handleInputChange = (e) => {
    console.log('Input changed:', e.target.value); // Debug için
    setInputValue(e.target.value);
    onChange(e.target.value);
  };

  // Input focus
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, []);

  const editorStyle = {
    position: 'absolute',
    top: position.top,
    left: position.left,
    width: position.width,
    height: position.height,
    zIndex: 1000,
    border: '2px solid #2196f3',
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    padding: '0',
    margin: '0',
    boxSizing: 'border-box'
  };

  return (
    <div className="cell-editor" style={editorStyle}>
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={() => onSave(inputValue)}
        className="cell-editor-input"
        placeholder="Değer veya formül girin..."
        autoFocus
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          outline: 'none',
          padding: '2px 4px',
          fontSize: 'inherit',
          fontFamily: 'inherit',
          backgroundColor: 'transparent',
          boxSizing: 'border-box'
        }}
      />
    </div>
  );
};

export default CellEditor;
